export default {
    // --------Title--------
    examineInventory: '检查库存',
    youCanSelectMultipleWarehouseLocationsToProceed: '可以选择多个仓库位置以继续',
    selectProducts: '选择商品',
    multipleSelectedItemsForExaminationResults: '选择多个物品进行检查结果',
    selectLocations: '选择仓库',
    scopeTheRangeOfTheSearchLocations: '确定搜索仓库范围',
    noDataFound: '暂无数据',
    relocateThresholdControl: '调整阈值控制',
    reorderThresholdControl: '复购阈值控制',

    // --------MUI--------
    startQuery: '开始查询',
    threshold: '阈值',
    suggestQty: '建议数量',

    // ----examine inventory---
    inStockBalance: '库存余量',
    transferInTransit: '在途库存',
    grossBalance: '总余量',
    pendingInbound: '待入库',
    stockTakeStock: '盘点库存',
    usageStock: '用量库存'


};